(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    

 $(document).ready(function(){

    var containerHeight = $('.about-section').height();

    $(window).scroll(function(){
       var scrollPosition = $(window).scrollTop();
        if (scrollPosition > (containerHeight))
        {
          if (scrollPosition < (containerHeight * 3)) {
            $('.about-left .image1').removeClass("show"); 
            $('.about-left .image2').addClass("show"); 
            $('.about-left .image3').removeClass("show");
            $('.about-left .images-sticky').removeClass("remove-transform");
          }

          else if (scrollPosition > (containerHeight * 3))
        {
          $('.about-left .image1').removeClass("show");
             $('.about-left .image2').removeClass("show");
             $('.about-left .image3').addClass("show");
             $('.about-left .images-sticky').addClass("remove-transform");
        }
        }
          
        else if (scrollPosition < (containerHeight / 2))
        {
            $('.about-left .image1').addClass("show"); 
            $('.about-left .image2').removeClass("show");
             $('.about-left .image3').removeClass("show");
          $('.about-left .images-sticky').removeClass("remove-transform");
        }

    }) // scroll function

})// end document
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slideshow"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  $('.homepage-slideshow').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    pauseOnHover: false,
    arrows: false
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-blog"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate();
});

  $('.mb-open').on('click', function() {
    $('.mobile-blog-categories').toggleClass('show');
    $('.mb-open').toggleClass('rotate');
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["room-gallery"] && !Shopify.designMode) return;
  try {
    

 $('.mb-open').on('click', function() {
    $('.mobile-blog-categories').toggleClass('show');
    $('.mb-open').toggleClass('rotate');
  });
  
  
  } catch(e) { console.error(e); }
})();
})();
